import { render, staticRenderFns } from "./drugsBulk.vue?vue&type=template&id=84255b50&"
import script from "./drugsBulk.vue?vue&type=script&lang=js&"
export * from "./drugsBulk.vue?vue&type=script&lang=js&"
import style0 from "./drugsBulk.vue?vue&type=style&index=0&id=84255b50&prod&scpoed=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports